export const EDIT_ACCOUNT = 'Edit Account';
export const DELETE_ACCOUNT = 'Delete Account';
